import { useStore } from '@nanostores/react'
import { ExecutionsUI } from 'features/executions'
import * as Scheduled from 'features/scheduled-messages'
import { memo } from 'react'

import css from './ChatHeader.module.scss'

function ChatHeader_() {
	const isRescheduleMode = useStore(Scheduled.$isScheduledShown)

	return isRescheduleMode ? (
		<Scheduled.UI.Header className={css.scheduled} />
	) : (
		<ExecutionsUI.ChatHeader className={css.header} />
	)
}

export const ChatHeader = memo(ChatHeader_)
